<template>
  <div class="card fit20-font-light activity-component-container">
    <img class="image" :src="photo" />
    <div class="text-sec">
    <p class="score">{{ score > 0 ? '+' + score + '%' : score + '%' }}</p>
    <p>{{ item }}</p>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'Activity',
  props: ['item', 'score', 'photo'],
};
</script>

<style>
.activity-component-container {
  color: rgb(78, 78, 78);
  display: flex;
  /* flex-direction: column; */
  width: 40%;
  margin:40px auto;
  align-items: center;
  justify-content: center;
  /* background-color: transparent; */
  font-weight: bold;
}
.activity-component-container:nth-child(1) {
  /* order: 3; */
  width: 50%;
  margin: 0 100px;
}
/* .card:nth-child(2) {
  order: 1;
}
.card:nth-child(3) {
  order: 2;
}
.card:nth-child(4) {
  order: 4;
}
.card:nth-child(5) {
  order: 5;
} */
.activity-component-container p {
  font-size: min(20px, calc(5px + 2vw));
}
.activity-component-container img {
  width: 50%;
  max-width: 125px;
  min-width: 70px;
  border-radius: 50%;
  margin: 3px;
}
.activity-component-container .score {
  color: #009fe3;
  font-size: min(24px, calc(12px + 1.4vw));
  width: min(200px, 50%);
}

.activity-component-container .text-sec {
  /* text-align: center; */
  padding-right: 15px;
  width: min(200px, 50%);
}

@media screen and (max-width: 640px) {
  .activity-component-container:nth-child(1) {
    width: 40%;
    margin: 0 100px;
  }

  .activity-component-container .text-sec {
    padding-right: 5px;
  }
}
</style>
